<template>
  <div id="activityPoster">
    <!-- <div class="main">
      <van-button round type="primary" @click="linkToShop">进入商城</van-button>
    </div> -->
  </div>
</template>
<script>
import { Button } from "vant";
import qcwyAPI from "../api/qcwy";
export default {
  name: "activityPoster",
  data() {
    return {
      userName: "",
      openid: "",
      link: "",
      IP: "",
      ap_id: "",
    };
  },
  methods: {
    ready() {
      //获取设备ip地址
  //  this.$axios.get("http://myip.ipip.net/", {}).then((res) => {
  //       let arr = res.data.split(" ");
  //       let IP = arr[1].split("：")[1];
  //       this.IP = IP;
        //埋点
        sensors.registerPage({
          platform_type: "利北小程序",
        });
        //自动采集
        sensors.quick("autoTrack", {
          platform: "利北小程序",
        });
        //获取埋点参数
        let url = window.location.href;
        
        let params = url.split("?")[1];
        console.log(222222222)
        if (params) {
          let userName = params.split("&")[0].split("=")[1];
          let openid = params.split("&")[1].split("=")[1];
          let link = decodeURIComponent(params.split("&")[2].split("=")[1]);
          let title = decodeURIComponent(params.split("&")[3].split("=")[1]);
          let ap_id = "";
          if (params.indexOf("ap_id") !== -1) {
            ap_id = decodeURIComponent(params.split("&")[4].split("=")[1]);
          } else {
            ap_id = -1;
          }
          sensors.setProfile({
            jwh5_openid: openid,
            jwh5_userName: userName,
          });
          console.log(11111111111)
          console.log(userName)
          console.log(title)
          // alert(3333)
          // sensors.track('test')
          sensors.track("scanForUser", {
            scan_userName: userName,
            scan_openid: openid,
            scan_activityTitle: title,
          });
          // alert(1111)
          this.userName = userName;
          this.openid = openid;
        // 修改参数的&拼接
        if(link.indexOf('?')==-1){
          this.link = link+"?userName = "+userName;
        }else{
          this.link = link+"&userName = "+userName;
        }
          this.ap_id = ap_id;
          // window.setTimeout(()=>{
            window.location.href=this.link;
          // },1000)
          // let data = {
          //   creater_openid: this.openid,
          //   title: title,
          //   ap_id: this.ap_id,
          //   ip: this.IP,
          // };
          // this.$axios
          //   .get(qcwyAPI.qcwyAPI.addScanTimes, { params: data })
          //   .then((res) => {
              
          // });
        }
      // });
    
    
      
    },
  },
  beforeCreate() {},
  created() {
    this.ready();
  },
};
</script>
<style scoped>
.main {
  position: fixed;
  top: 50%;
}
</style>


// WEBPACK FOOTER //
// src/pages/activityPoster.vue